import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import contactService from '../../../../Services/contactService';
import ErrorMessage from '../../../ErrorMessage';

export default class ContactSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
    onlyActive: false,
    onlyWithAddress: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    contactService
      .GetContactListByClientId(this.props.idFilter, this.props.onlyWithAddress ?? false)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((contact, index) => {
          if ((!this.props.onlyActive || contact.isActive === true) && contact.addressId !== '') {
            if (this.props.onlyWithAddress) {
              optValues.push({
                label: `${contact.name} - ${contact.addressName}`,
                value: contact.contactId,
                disabled: false,
              });
            } else {
              optValues.push({ label: contact.name, value: contact.contactId, disabled: false });
            }
          }
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('COS62');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
